
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'

export default class Title extends React.Component {
  render() {
    return <div className='title'>{this.props.children}</div>
  }
}



// WEBPACK FOOTER //
// ./client/components/Title/index.js